export default __webpack_public_path__ + "static/media/preparo.8b4e92ec.svg";